import contactMethodsFormValidationSchema from '@components/forms/components/ContactMethodForm/validations';
import { z } from 'zod';

// useful type for testing
export type EditContactsValidationType = z.TypeOf<
  typeof editContactsValidationSchema
>;

export const editContactsValidationSchema = z.object({
  editContacts: z.object({
    contacts: contactMethodsFormValidationSchema,
  }),
});

export default editContactsValidationSchema;
